var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96804 10.6068V10.6063H0.000488281V7.19466H2.96804V7.19417H2.96852V4.5932C2.96852 3.11388 3.40478 1.96572 4.17473 1.18738C4.94468 0.409048 6.04837 0.000488281 7.38333 0.000488281C8.02277 0.000488281 8.67692 0.0581318 9.17121 0.115776C9.41835 0.144598 9.62553 0.17342 9.77092 0.195037C9.84362 0.205845 9.90087 0.214852 9.93994 0.221157L9.98458 0.228475L9.99604 0.230402L9.99894 0.230897L9.99951 0.230994V3.13543H8.52598C7.79981 3.13543 7.32342 3.36298 7.02858 3.70733C6.73375 4.05166 6.62052 4.51271 6.62052 4.97959V7.19417H6.621V7.19466H9.86245L9.34433 10.6063H6.621V10.6068H6.62052V18.8562C6.02554 18.9504 5.41572 18.9995 4.79452 18.9995C4.17332 18.9995 3.56351 18.9504 2.96852 18.8562V10.6068H2.96804Z",
    fill: "#A8C956",
    stroke: "#BDBDBD",
    strokeWidth: 0.000976562
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5d25058421c8683e7e9ebcb6dcb0dd8c.svg";
export { ForwardRef as ReactComponent };